export default __webpack_public_path__ + "static/media/santiago.2d68dddb.png";